import { css } from '@emotion/css'
import { spacing } from '../../../styles'
import getThemeColors from '../../../themes'

const styles = {
  icon: css({
    borderRadius: '50%',
    width: 20,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 auto',
    marginRight: spacing.small,
  }),
}

export default styles

export const iconTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    backgroundColor: themed.light,
  })
}

export const iconColor = theme => {
  const themed = getThemeColors(theme)
  return themed.base
}
